import {useLocation} from 'react-router-dom';
import {useCurrentWorkspaceUrlPrefix} from '@tinct/core-workspace';
import {useJobAlert} from '@tinct/web-layout';

export function useSnippetVerificationJobAlert() {
  const workspaceUrl = useCurrentWorkspaceUrlPrefix();
  const {pathname} = useLocation();

  const {start} = useJobAlert({
    name: 'Snippet Verification',
    pendingUrl: pathname,
    completedUrl: `${workspaceUrl}/settings/snippet`,
  });

  return {start};
}
